module.exports = __webpack_public_path__ + "static/media/Petra-tou-Romiou-10200.e599c0ac.jpg";